"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToBuy = addToBuy;
exports.createInstances = createInstances;
exports.unifyListAdd = unifyListAdd;
exports.unifyListDel = unifyListDel;
exports.unifyListModify = unifyListModify;
exports.unifyListQuery = unifyListQuery;
exports.unifyListSubmit = unifyListSubmit;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var axios = new _axios.default({
  extra: {
    componentName: 'buyList'
  }
});

// 购物清单
// 查询购物清单
function unifyListQuery(regionId, params) {
  // return get("/localAPI/unifyListQuery", params, {});
  return axios({
    url: '/openApi/universe/query',
    method: 'GET',
    params: _objectSpread({
      regionId: regionId
    }, params)
  });
}
// 添加到购物车
function addToBuy(regionId, params) {
  // return post("/localAPI/addBuy", params, {});
  return axios({
    url: '/openApi/buy/addBuy',
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: params
    }
  });
}
// 购物清单添加
function unifyListAdd(params) {
  // return post("/localAPI/unifyListAdd", params, {});
  return axios({
    url: '/openApi/universe/add',
    method: 'POST',
    data: {
      params: params
    }
  });
}

// 删除清单中某个商品
function unifyListDel(params) {
  // return get("/localAPI/unifyListDel", params, {});
  return axios({
    url: '/openApi/universe/del',
    method: 'DELETE',
    params: {
      params: params
    }
  });
}

// 修改清单中某个商品
function unifyListModify(params) {
  // return post("/localAPI/unifyListModify", params, {});
  return axios({
    url: '/openApi/universe/modify',
    method: 'POST',
    data: {
      params: params
    }
  });
}

// 提交购物清单
function unifyListSubmit(params) {
  // return post("/localAPI/unifyListSubmit", params, {});
  return axios({
    url: '/openApi/universe/submit',
    method: 'POST',
    data: {
      params: params
    }
  });
}

// 创建实例
function createInstances(type, regionId, params) {
  // return post("/localAPI/createInstances", params, {});
  var _requestUrl = '';
  switch (type) {
    case 'vm':
      _requestUrl = '/openApi/vm/createInstances';
      break;
    case 'disk':
      _requestUrl = '/openApi/disk/createDisks';
      break;
    case 'ip':
      _requestUrl = '/openApi/vpc/createElasticIps';
      break;
  }
  return axios({
    url: _requestUrl,
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: params
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/buy-list.js
// module id = rFqL
// module chunks = 19